/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { coalesce } from '@gh/core-util';
import { ICellRendererParams } from 'ag-grid-community';
import { isFunction } from 'lodash';
import { GridCellRendererComponent } from '../../grid-component.interfaces';

@Component({
  standalone: false,
  selector: 'gh-grid-tooltip-cell-renderer',
  template: `
    <div class="m-body" [matTooltip]="tooltip" matTooltipClass="m-cell-renderer-tooltip tooltip-large-font">
      {{ text }}
    </div>`,
  styleUrls: ['grid-tooltip-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTooltipCellRendererComponent implements GridCellRendererComponent {
  text: string;
  tooltip: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {

  }

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: any): boolean {
    const tooltip = params['tooltip'];
    this.tooltip = isFunction(tooltip) ? tooltip(params) : tooltip;
    this.text = coalesce(params.valueFormatted, params.value);
    this.changeDetectorRef.markForCheck();
    return true;
  }
}
